import { ProductType } from '../../types';
import TVComponent from '../components/TVComponent';
import { isOfType } from '../resolvers/common';
import { PlannerValidation } from './PlannerValidation';
// Validation rule to not snap frames to hidden walls
export class TvOnWallsValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'TvOnWallsValidation');
        this.coreApi = coreApi;
        this.enabled = true;
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!this.enabled || !entity.hasComponent(TVComponent.id)) {
            return this.validationOK();
        }
        const wallVisibility = this.coreApi.scene?.getWallVisibility();
        if (!wallVisibility) {
            return this.validationFail('Can´t get wall visibility');
        }
        const isTVWithFoot = isOfType([ProductType.TV_WITH_FOOT]);
        if (isTVWithFoot(entity)) {
            return this.validationOK();
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=TvOnWallsValidation.js.map